import BaseService from "../baseService";
import httpService from "../http/httpService";

let APP_BASE_URL = "/interact/appkeydata";
let APP_SETTINGS_URL = APP_BASE_URL + "/settings/:appKey";
let MOBILE_LOAD_SOURCE_URL = APP_BASE_URL + '/mobile/loadFrom';


class ApplicationRemoteService extends BaseService {

	constructor() {
		super("com.jacada.common.services.application.ApplicationRemoteService");
	}

	getApplicationSettings(settings) {

		let _this = this;

		/* Build request header */
		let headers = {};
		headers["Content-Type"] = "application/json";

		let pathParams = {};
		pathParams.appKey = settings.getApplicationKey();

		let queryParams = {};
		queryParams.includeAppTranslation = "false";

		return httpService.execute({
			headers  : headers,
			path: APP_SETTINGS_URL,
			pathParams: pathParams,
			queryParams: queryParams,
			method: 'GET'
		});
	}

	getApplicationById(id) {
		return httpService.execute(
			{
				method: 'GET',
				path: '/interact/appkeydata/'+ id
			}
		);
	};

	getMobileLoadSource() {
		return httpService.execute(
			{
				method: 'GET',
				path: MOBILE_LOAD_SOURCE_URL,
			}
		);
	};

	generateAppKey() {
		return httpService.execute(
			{
				method: 'PUT',
				path: '/interact/appkeydata/internal/generate',
			}
		)
	};

	createApplication(applicationData) {
		return httpService.execute(
			{
				method: 'POST',
				path: '/interact/appkeydata',
				data: applicationData
			}
		)
	};

	saveApplicationData(applicationData, validateContactUs) {
		return httpService.execute(
			{
				method: 'PUT',
				path: '/interact/appkeydata?validateContactUs=' + validateContactUs,
				data: applicationData
			}
		);
	};

	getChannelTypeDefaultProperties(channelType) {
		return httpService.execute(
			{
				method: 'GET',
				path: '/interact/appkeydata/defaultProperties/' + channelType
			}
		);
	};

	getApplications(appDataType) {
		appDataType = appDataType || "JACADA_APPLICATION";

		return  httpService.execute(
			{
				method: 'GET',
				path: '/interact/appkeydata/appList',
				queryParams: {
					dataType: appDataType
				}
			}
		);
	};

	getApplicationsByChannelTypes(channelTypes, headers) {
		return  httpService.execute(
			{
				method: 'POST',
				path: '/interact/appkeydata/channelTypes',
				data: JSON.stringify(channelTypes),
                headers: headers,
				queryParams: {
					applicationType:"JACADA_APPLICATION",
					filter: true
				}
			}
		)
	};

	setApplicationStatus(appId, enabled) {
		return  httpService.execute(
			{
				method: 'PUT',
				path: '/interact/appkeydata/' + appId + '/enabled/' + enabled
			}
		);
	};

	getChannelTypesForNewApplication() {
		return  httpService.execute(
			{
				method: 'GET',
				path: '/interact/appkeydata/newApplication/channelTypes'
			}
		);
	};

	getChannelTypesAllowedByLicense() {
		return  httpService.execute(
			{
				method: 'GET',
				path: '/interact/tenant/allowedChannelTypes'
			}
		);
	};

    getLoginApplicationURL(settings) {
        let headers = {};
        headers["Content-Type"] = "application/json";
        let queryParams = {};
        if(settings.getApplicationKey()) {
            queryParams.appKey = settings.getApplicationKey();
        }
        return httpService.execute({
            headers  : headers,
            path: 'interact/appkeydata/loginUrl',
            queryParams: queryParams,
            method: 'GET'
        });
    };
}

export default new ApplicationRemoteService();


// WEBPACK FOOTER //
// ../common/services/src/application/applicationRemoteService.js